import * as Sentry from "@sentry/astro";

Sentry.init({
  dsn: "https://7fd9b0c60fc60a2d1f381da8e3f4a81e@o4509032058388480.ingest.us.sentry.io/4509032061403136",
  debug: false,
  environment: "production",
  release: import.meta.env.PUBLIC_VERCEL_GIT_COMMIT_SHA,
  tracesSampleRate: 1,
  integrations: [Sentry.browserTracingIntegration()],
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 0,
});